<ng-container *transloco="let t">
  <div class="skip-to-content">
    <a
      class="skip-to-content"
      [attr.href]="(currentUrl$ | async) + '#' + mainId"
      >{{ t('header_skip_to_content') }}</a
    >
  </div>
</ng-container>
